// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__24YBn","range":"MonthRangeSwitch_range__2IVn7","disabled":"MonthRangeSwitch_disabled__1mz3O"};